<template>
<v-container grid-list-md text-xs-center>
  <v-layout row wrap>
    <v-flex xs9>
      <draggable class="scroll" v-model="fields">
        <div v-for="(data, index) in fields" :key="data.id">
          <component :is="fieldComponent(data.type)" :key="data.id" :index="index" :context="createContext()" :data="data"></component>
        </div>
      </draggable>
    </v-flex>
    <v-flex xs3>
      <v-btn round v-for="button in buttons" :key="button.type" dark block color="blue-grey darken-3" @click="appendField(button.type)">{{ button.label }}</v-btn>
      <v-text-field v-model="inputAfter" label="Wstaw po" type="number"></v-text-field>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import draggable from 'vuedraggable'
import Field from '../fields/Field'
import PredefinedField from '../fields/PredefinedField'
import TableField from '../fields/TableField'
import fieldTypeEnum from '@/enums/fieldType'
import Context from '@/plugins/Context'

export default {
  components: {
    draggable,
    Field,
    PredefinedField,
    TableField
  },
  data() {
    return {
      inputAfter:0,
      buttons: [{
          type: fieldTypeEnum.TEXT,
          label: this.$t('schema.builder.inputs.text-field')
        },
        {
          type: fieldTypeEnum.NUMBER,
          label: this.$t('schema.builder.inputs.number-field')
        },
        {
          type: fieldTypeEnum.DATE,
          label: this.$t('schema.builder.inputs.date-field')
        },
        {
          type: fieldTypeEnum.TIME,
          label: this.$t('schema.builder.inputs.time-field')
        },
        {
          type: fieldTypeEnum.RADIO,
          label: this.$t('schema.builder.inputs.radio-field')
        },
        {
          type: fieldTypeEnum.TABLE,
          label: this.$t('schema.builder.inputs.table')
        },
        {
          type: fieldTypeEnum.MULTIPLE,
          label: this.$t('schema.builder.inputs.multiple-field')
        },
        {
          type: fieldTypeEnum.SIGNATURE,
          label: this.$t('schema.builder.inputs.signature-field')
        },
        {
          type: fieldTypeEnum.PHOTO,
          label: this.$t('schema.builder.inputs.photo-field')
        },
        {
          type: fieldTypeEnum.CODE,
          label: this.$t('schema.builder.inputs.code-field')
        },
        {
          type: fieldTypeEnum.FORMULE,
          label: this.$t('schema.builder.inputs.formule-field')
        },
        {
          type: fieldTypeEnum.ARCHIVE,
          label: this.$t('schema.builder.inputs.archive-field')
        },
        {
          type: fieldTypeEnum.RELATED,
          label: this.$t('schema.builder.inputs.related-field')
        },
        {
          type: fieldTypeEnum.DEPEND,
          label: this.$t('schema.builder.inputs.select-depend-field')
        },
        {
          type: fieldTypeEnum.CHECKBOX,
          label: this.$t('schema.builder.inputs.checkbox-field')
        },
        {
          type: fieldTypeEnum.STORAGE,
          label: this.$t('schema.builder.inputs.storage-field')
        },
        {
          type: fieldTypeEnum.GEOLOCATION,
          label: this.$t('schema.builder.inputs.geolocation-field')
        }
      ]
    }
  },
  computed: {
    fields: {
      get() {
        return this.$store.state.schemaBuilder.fields
      },
      set(payload) {
        this.$store.commit('updateFields', payload)
      }
    }
  },
  methods: {
    createContext() {
      return Context.createFormContextWithFields(this.$store.state.schemaBuilder.fields)
    },
    fieldComponent(type) {
      if (type === fieldTypeEnum.TABLE) {
        return 'table-field'
      } else if (fieldTypeEnum.predefined.includes(type)) {
        return 'predefined-field'
      } else {
        return 'field'
      }
    },
    appendField(type) {
      let payload = {
        id: this.$uuid(),
        type,
        name: "",
        description: "",
        location: null
      }
      if (type === fieldTypeEnum.TABLE) {
        payload["sub-fields"] = []
      } else if (fieldTypeEnum.predefined.includes(type)) {
        payload["values"] = []
      }
      payload["options"] = {}

      payload.inputAfter = this.inputAfter
      this.$store.commit("appendFieldAfterIndex", payload)
      this.changeInputAfter()
    },
    changeInputAfter(){
      if(this.inputAfter == this.$store.state.schemaBuilder.fields.length-1){
        this.inputAfter++
      }
    }

  },
  created() {
    this.inputAfter = this.$store.state.schemaBuilder.fields.length
  }
}
</script>
<style scoped>
.scroll {
  height: 500px;
  overflow-y: scroll;
}

@media only screen and (max-height: 500px) {
  .scroll {
    height: 300px;
  }
}

@media only screen and (min-height: 500px) {
  .scroll {
    height: 350px;
  }
}

@media only screen and (min-height: 600px) {
  .scroll {
    height: 430px;
  }
}

@media only screen and (min-height: 700px) {
  .scroll {
    height: 520px;
  }
}

@media only screen and (min-height: 1000px) {
  .scroll {
    height: 700px;
  }
}
</style>
